import { z } from "zod";

/**
 * schemas
 */

export const DelegationStatus = {
  Undelegated: "Undelegated",
  Pending: "Pending",
  Delegated: "Delegated",
  Expired: "Expired",
  Errored: "Errored",
} as const;
export type DelegationStatus =
  (typeof DelegationStatus)[keyof typeof DelegationStatus];
export const delegationStatusValues = Object.values(DelegationStatus) as [
  DelegationStatus,
  ...DelegationStatus[],
];

export const delegationStatusSchema = z.enum(delegationStatusValues);

// api schemas

export const delegationStatusRequestSchema = z.object({
  address: z.string(),
  chainId: z.number(),
});
export type DelegationStatusRequest = z.infer<
  typeof delegationStatusRequestSchema
>;

export const delegationStatusResponseSchema = z.object({
  delegationStatus: delegationStatusSchema,
});
export type DelegationStatusResponse = z.infer<
  typeof delegationStatusResponseSchema
>;

export const delegationCreateRequestSchema = z.object({
  signedAuthorization: z.string(),
  signerAddress: z.string(),
});
export type DelegationCreateRequest = z.infer<
  typeof delegationCreateRequestSchema
>;

export const delegationCreateResponseSchema = z.preprocess(
  (value) => {
    if (typeof value === "string") {
      return { success: true, transactionHash: value };
    }
    return value;
  },
  z.object({
    success: z.boolean(),
    transactionHash: z.string().optional(),
    message: z.string().optional(),
  }),
);
export type DelegationCreateResponse = z.infer<
  typeof delegationCreateResponseSchema
>;
